import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import {
  ResponseData,
  ProfileForm,
  AddressForm,
  SubscriptionFormInput,
  Pagination,
} from "../model/interface.model";

@Injectable({
  providedIn: "root",
})
export class ProfileService {
  endpoint: string = environment.endpoint;
  constructor(private http: HttpClient) {}

  userInfoBasic() {
    return this.http.get<ResponseData>(this.endpoint + "/user/profile");
  }

  updateProfile(request: ProfileForm) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/update_basic_profile",
      request
    );
  }

  updateAddress(request: AddressForm) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/update_address",
      request
    );
  }

  uploadProfilePic(request: FormData) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/upload_profile_pic",
      request
    );
  }

  getProfileImage(request: string) {
    return this.http.get(this.endpoint + "/user/profile_image/" + request, {
      responseType: "blob",
    });
  }

  getMobileVerificationToken(request: { number: string }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/get_mobile_token",
      request
    );
  }

  verifyMobileNumber(request: { number: string; token: string }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/verify_mobile_number",
      request
    );
  }

  updatePassword(request: { password: string }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/reset_password",
      request
    );
  }

  uploadDocuments(request: FormData) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/upload_document",
      request
    );
  }

  getDocuments(pagination: Pagination) {
    let filter = "&filter=" + false;
    if (pagination.filter !== null) {
      filter = "&filter=" + true;

      if (pagination.filter.start_date !== null)
        filter += "&start_date=" + pagination.filter.start_date;

      if (pagination.filter.end_date !== null)
        filter += "&end_date=" + pagination.filter.end_date;

      if (pagination.filter.doc_type !== null)
        filter += "&doc_type=" + pagination.filter.doc_type;

      if (pagination.filter.doc_status !== null)
        filter += "&doc_status=" + pagination.filter.doc_status;
      filter += "&from_filter=" + pagination.from_filter;
    }

    return this.http.get<ResponseData>(
      this.endpoint +
        "/user/get_documents?current=" +
        pagination.current +
        "&limit=" +
        pagination.limit +
        filter
    );
  }

  getAccountLogs(pagination: { current: number; limit: number }) {
    return this.http.get<ResponseData>(
      this.endpoint +
        "/user/get_account_log?current=" +
        pagination.current +
        "&limit=" +
        pagination.limit
    );
  }

  getSubscriptions() {
    return this.http.get<ResponseData>(
      this.endpoint + "/user/get_account_subscription"
    );
  }

  updateSubscriptions(request: SubscriptionFormInput) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/update_user_subscription",
      request
    );
  }

  updateAuthByEmail_2FA(request: { auth_by_email: boolean }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/update_2fa_email",
      request
    );
  }

  getAuthBy2FA() {
    return this.http.get<ResponseData>(this.endpoint + "/user/get_2fa");
  }

  getGoogleAuthQr() {
    return this.http.get<ResponseData>(this.endpoint + "/user/get_2fa_code_qr");
  }

  enableGoogleAuth(request: { code: string }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/enable_2fa_google",
      request
    );
  }

  disableGoogleAuth() {
    return this.http.get<ResponseData>(
      this.endpoint + "/user/disable_google_auth"
    );
  }

  addBankaccount(request: {
    bankname: string;
    account_holder_name: string;
    country?: string;
    account_number: string;
    ifsc_code?: string;
    swift_code?: string;
    bank_details?: string;
  }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/user/add_back_account",
      request
    );
  }

  getUserBankaccounts() {
    return this.http.get<ResponseData>(
      this.endpoint + "/user/get_bank_account"
    );
  }
}
